import React from "react";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";
import EventsTable from "./EventsTable";

const Events = () => {
    // context
    const {
        setEventCover,
        setEventMedia,
        setEventLinks,
        setTextEditorHTML,
        setEventTitle,
        setEventTags,
        setSelectedEventId,
        setEventCoverId,
        setEventEndDate,
        setEventStartDate,
    } = useContext(context);
    // functions
    const handleEmptyFields = () => {
        setEventTitle("");
        setEventCover([]);
        setEventMedia([]);
        setEventLinks([]);
        setEventCoverId();
        setTextEditorHTML("");
        setEventTags([]);
        setSelectedEventId();
        setEventStartDate();
        setEventEndDate();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addEvent">
                    <Button onClick={handleEmptyFields} type="primary">
                        اضافه کردن رویداد جدید
                    </Button>
                </NavLink>
            </Space>
            <EventsTable />
        </>
    );
};

export default Events;
